<template>
  <svg width="53" height="54" viewBox="0 0 53 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.75 27H37.3373M27.9688 15.25L37.2911 25.9041C37.8401 26.5316 37.8401 27.4684 37.2911 28.0959L27.9688 38.75" stroke="black" stroke-width="2.4963" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
